import { cn } from '@/lib/utils';

interface ColorPickerSkeletonProps {
  className?: string;
}

const ColorPickerSkeleton = ({ className }: ColorPickerSkeletonProps) => {
  return (
    <div className={cn('p-4 rounded-xl border border-border/50 bg-background/50 shadow-lg', className)}>
      <div className="grid grid-cols-3 gap-3">
        {Array.from({ length: 9 }).map((_, index) => (
          <div
            key={index}
            className="aspect-square rounded-xl bg-muted/50 animate-pulse"
          />
        ))}
      </div>
    </div>
  );
};

export default ColorPickerSkeleton;